var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wechat-user-manage" },
    [
      _c(
        "basic-container",
        [
          _c("WeChatUserManageSearch", {
            attrs: {
              tagOptions: _vm.tagOptions,
              leboTagOptions: _vm.leboTagOptions,
              searchForm: _vm.searchForm,
            },
            on: { search: _vm.handleSearch, batchEdit: _vm.handleBatchEdit },
          }),
          _c("WeChatUserManageTable", {
            attrs: { tableData: _vm.tableData, loading: _vm.loading },
            on: {
              view: _vm.handleView,
              edit: _vm.handleEdit,
              record: _vm.handleRecord,
            },
          }),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("ElementPagination", {
                attrs: {
                  "current-page": _vm.page.current,
                  "page-size": _vm.page.size,
                  "page-sizes": [10, 20, 30, 50, 100],
                  total: _vm.page.total,
                  layout: "total, sizes, prev, pager, next, jumper",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("BatchEditDialog", {
        attrs: {
          visible: _vm.batchEditVisible,
          tagOptions: _vm.tagOptions,
          leboTagOptions: _vm.leboTagOptions,
        },
        on: {
          "update:visible": function ($event) {
            _vm.batchEditVisible = $event
          },
          submit: _vm.handleBatchSubmit,
          close: _vm.handleBatchCloseDialog,
        },
      }),
      _c("UserDetailDialog", {
        attrs: {
          visible: _vm.userDetailVisible,
          rowData: _vm.currentRowData,
          mode: _vm.userDetailMode,
          tagOptions: _vm.tagOptions,
          leboTagOptions: _vm.leboTagOptions,
        },
        on: {
          "update:visible": function ($event) {
            _vm.userDetailVisible = $event
          },
          submit: _vm.handleDetailSubmit,
        },
      }),
      _c("RecordDialog", {
        attrs: { visible: _vm.recordVisible, openid: _vm.recordOpenid },
        on: {
          "update:visible": function ($event) {
            _vm.recordVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }